import { getNation, getDict, getAreaData, getDivision, postSalary, getTreeDict, postDict } from 'api/api'
import { treeType } from 'utils/constant';
import { Cascader } from 'antd-mobile'
import { keysConstant } from './constant/key';

const { T_DIC_PROTECH, T_DIC_PROQUALITY, T_DIC_AREACODE, FUJIAN, NATION } = keysConstant

// 获取数据的通用方法

/**
 * 获取户籍地址接口信息
 * @param {*} extend   
 * @param {*} areaContent  
 * @param {*} setAreaContent 
 */
async function getAreaObj(extend, areaContent, setAreaContent, onlyFJ = false) {
  if (!Array.isArray(extend)) {
    const column = await getAreaData(NATION)
    setAreaContent(column.map(item =>
      ({ label: item.FNAME, value: item.ID, type: item.FTYPE, children: Cascader.optionSkeleton })
    ))
  } else {
    const lastItem = extend[extend.length - 1]
    const type = lastItem.type
    if (type === 5) {
      return
    }
    const column = await getAreaData(lastItem.value)
    if (type === 4) {
      lastItem.children = column.map(item =>
        ({ label: item.FNAME, value: item.ID, type: item.FTYPE })
      )
    } else {
      lastItem.children = column.map(item =>
        ({ label: item.FNAME, value: item.ID, type: item.FTYPE, children: Cascader.optionSkeleton })
      )
    }
    setAreaContent([...areaContent])
  }
}

/**
 * 获取福建省内行政区划信息
 * @param {*} extend 
 * @param {*} areaContent 
 * @param {*} setAreaContent 
 */
async function getFJAreaObj(extend, areaContent, setAreaContent) {
  if (!Array.isArray(extend)) {
    // const column = await getAreaData(-1)
    const column = await getAreaData(FUJIAN)
    setAreaContent(column.map(item =>
    ({
      label: item.FNAME, value: item.ID,
      children: Cascader.optionSkeleton, key: item.ID,
      type: item.FTYPE
      // isLeaf: item.FTYPE === 3
    })
    ))
  } else {
    const lastItem = extend[extend.length - 1]
    const type = lastItem.type
    if (type === 3) {
      return
    }
    const column = await getAreaData(lastItem.value)
    if (type === 2) {
      lastItem.children = column.map(item =>
        ({ label: item.FNAME, value: item.ID, type: item.FTYPE })
      )
    } else {
      lastItem.children = column.map(item =>
      ({
        label: item.FNAME, value: item.ID, type: item.FTYPE,
        children: Cascader.optionSkeleton
      })
      )
    }
    setAreaContent([...areaContent])
  }
}

/**
 * 获取单选框数据
 * @param {*} api  接口
 * @param {*} key  字典key
 * @param {*} name 字典名称 
 * @param {*} content  数据
 * @param {*} setContent 设置数据 
 */
async function getUserObj(api, key, name, content, setContent) {
  const UserObjContent = await api(key)
  if (UserObjContent) {
    const newContent = UserObjContent.map(
      item => (
        api === getNation
          ?
          { label: item.NAME, value: item.ID }
          :
          api === getDict
            ?
            { label: item.name, value: item.id }
            :
            api === getAreaData
              ?
              { label: item.FNAME, value: item.FID || item.ID }
              :
              api === postSalary
                ?
                { label: item.FSALARY, value: item.FGEAR }
                :
                null
      )
    )
    // 将数据存入content，并将name作为key
    setContent({ ...content, [name]: newContent })
  } else {
    setContent({ ...content, [name]: [{ label: '暂无数据', value: '' }] })
  }
}

/**
 * 获取就业地址信息（福建省内）五级表
 * @param {*} extend 
 * @param {*} jobWantContent 
 * @param {*} setJobWantContent 
 */
async function getJobWantedObj(extend, jobWantContent, setJobWantContent) {
  if (!Array.isArray(extend)) {
    const column = await getAreaData(20)
    setJobWantContent(column.map(item =>
      ({ label: item.FNAME, value: item.ID, children: [] })
    ))
  } else {
    const lastItem = extend[extend.length - 1]
    if (extend.length < 2) {
      const column = await getAreaData(lastItem.value)
      lastItem.children = column.map(item =>
        ({ label: item.FNAME, value: item.ID, children: undefined })
      )
      setJobWantContent([...jobWantContent])
    }
  }
}

/**
 * 获取就业地址信息（福建省内）三级表 getDivision
 * @param {*} extend 
 * @param {*} jobWantContent 
 * @param {*} setJobWantContent 
 */
async function getFJJobWantedObj(extend, jobWantContent, setJobWantContent) {
  if (!Array.isArray(extend)) {
    const column = await getDivision(T_DIC_AREACODE)
    setJobWantContent(column.map(item =>
    ({
      label: item.name, value: item.id,
      children: Cascader.optionSkeleton,
      key: item.pid
    })
    ))
  } else {
    const lastItem = extend[extend.length - 1]
    if (extend.length < 2) {
      const column = await getDivision(lastItem.value)
      lastItem.children = column.map(item =>
        ({ label: item.name, value: item.id, key: item.pid })
      )
      setJobWantContent([...jobWantContent])
    }
  }
}

/**
 * 获取职业(工种)资格接口信息
 * @param {*} extend 
 * @param {*} key 数据字典对应表单的key
 * @param {*} skillContent 
 * @param {*} setSkillContent 
 */
async function getSkillObj(extend, key, skillContent, setSkillContent) {
  if (!Array.isArray(extend)) {
    const column = await postDict(null, T_DIC_PROQUALITY)
    const newColumn = column.filter(item => item.GRADE === 1)
    setSkillContent(newColumn.map(item =>
    ({
      label: item.NAME, value: item.ID,
      children: Cascader.optionSkeleton,
      type: item.TYPE, key: item.ID
    })
    ))
  } else {
    const lastItem = extend[extend.length - 1]
    if (lastItem.type === treeType.END) {
      return
    }
    const column = await getTreeDict(key, lastItem.value)
    if (column.length) {
      lastItem.children = column.map(item => {
        if (item.TYPE === treeType.END) {
          return {
            label: item.NAME,
            value: item.ID,
            type: item.TYPE, key: item.ID
          }
        } else {
          return {
            label: item.NAME,
            value: item.ID, children: Cascader.optionSkeleton,
            type: item.TYPE, key: item.ID
          }
        }
      }
      )
    }
    setSkillContent([...skillContent])
  }
}

/**
 * 获取职称接口信息
 * @param {*} extend 
 * @param {*} key 
 * @param {*} postContent 
 * @param {*} setPostContent 
 */
async function getPostObj(extend, key, postContent, setPostContent) {
  if (!Array.isArray(extend)) {
    const column = await postDict(null, T_DIC_PROTECH)
    const newColumn = column.filter(item => item.GRADE === 1)
    const newContent =
      newColumn.map(item =>
      ({
        label: item.NAME, value: item.ID,
        children: Cascader.optionSkeleton,
        type: item.TYPE, key: item.ID
      })
      )
    setPostContent(newContent)
  } else {
    const lastItem = extend[extend.length - 1]
    //type 0 普通节点 1 根节点 2 末节点
    if (lastItem.type === treeType.END) {
      return
    }
    const column = await getTreeDict(key, lastItem.value)
    if (column.length) {
      lastItem.children = column.map(item => {
        if (item.TYPE === treeType.END) {
          return {
            label: item.NAME,
            value: item.ID,
            type: item.TYPE, key: item.ID
          }
        } else {
          return {
            label: item.NAME,
            value: item.ID, children: Cascader.optionSkeleton,
            type: item.TYPE, key: item.ID
          }
        }
      }
      )
    }
    setPostContent([...postContent])
  }
}

/**获取表单随机ID*/
function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line no-bitwise
    const r = Math.random() * 16 | 0
    // eslint-disable-next-line no-bitwise
    // eslint-disable-next-line no-mixed-operators
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}


export {
  getAreaObj,
  getFJAreaObj,
  getUserObj,
  getJobWantedObj,
  getFJJobWantedObj,
  getSkillObj,
  getPostObj,
  guid
}